<template>
    <overlay
        v-if="isAsideMobileExpanded"
        position="justify-start"
        @overlay-click="cancel"
    >
        <aside
            v-show="isAsideMobileExpanded"
            class="shadow-2xl fixed z-40 h-[100svh] overflow-y-auto bg-white from-green-50 via-blue-50 to-white w-2/3 px-1 py-4"
            style="overflow:scroll;"
        >
            <close-icon
                class="ml-6"
                :width="20"
                :height="20"
                :stroke-color="'rgba(0,0,0,0.8)'"
                @click="cancel"
            />
            <div class="mt-6 px-4">
                <template
                    v-for="(menuGroup, index) in menu"
                    :key="`b-${index}`"
                >
                    <aside-menu-list
                        class="mb-2"
                        :menu="menuGroup"
                        :is-aside-mobile="isAsideMobileExpanded"
                        :show-submenu-info="showSubmenuInfo"
                        @menu-click="menuClick"
                        @toggle-sidebar="toggleSidebar"
                    />
                </template>
            </div>
        </aside>
    </overlay>
</template>

<script>
import AsideMenuList from '@/spComponents/Utilities/AsideMenuList'
import CloseIcon from '@/assets/img/CloseIcon'
import Overlay from '@/spComponents/Utilities/Overlay'
import { LocalStorage } from 'ttl-localstorage'
import { computed, inject } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'AsideMenu',
    components: {
        AsideMenuList,
        CloseIcon,
        Overlay
    },
    props: {
        menu: {
            type: Array,
            default: () => []
        }
    },
    emits: ['open-modal'],
    setup (props, { emit }) {
        const store = useStore()
        const isFullScreen = computed(() => store.state.isFullScreen)
        const toggleSidebar = () =>{
            store.dispatch('asideMobileToggle')
        }
        const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
        const showSubmenuInfo = computed(() => store.state.showSubmenuInfo)
        // const $http = inject('$http')
        const $swal = inject('$swal')
        // const router = useRouter()

        const confirmGoSpoplus = () => {
            $swal.fire({
                text: 'SPO+ TOPに戻りますか？',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'rgba(239,186,99,0.91)',
                confirmButtonText: 'はい',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    goSpoplus()
                }
            })
        }

        const menuClick = (event, item) => {
            console.log(item?.submenu?.length, 'menuClick')
            if (item?.submenu?.length) {
                const payload = {
                    isShow: !showSubmenuInfo.value,
                    label: item.label
                }
                store.dispatch('showSubmenuToggle', payload)
                return
            }

            if (item.label === 'お問い合わせ') {
                console.log('お問い合わせ')
                emit('open-modal', { type: 'inquiry' })
            }

            if (['利用規約', 'プライバシーポリシー'].includes(item.label)) {
                window.open(item.to, '_blank')
            }

            if (item.label === 'Topに戻る') {
                confirmGoSpoplus()
            }

            if(item.label === 'ログアウト'){
                logout()
            }

            if (item.externalLink) {
                window.open(item.externalLink, '_blank')
                return
            }
            store.dispatch('asideMobileToggle')
        }

        const logout = () => {
            $swal.fire({
                text: 'ログアウトしますか？',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'rgba(239,186,99,0.91)',
                confirmButtonText: 'はい',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.isConfirmed) {
                    LocalStorage.clear()
                    caches.keys().then(function(cacheNames) {
                        return Promise.all(
                            cacheNames.filter(function(cacheName) {
                                // Return true if you want to remove this cache,
                                // but remember that caches are shared across
                                // the whole origin
                            }).map(function(cacheName) {
                                return caches.delete(cacheName)
                            })
                        )
                    })
                    navigator.serviceWorker.getRegistrations()
                        .then(registrations => {
                            registrations.forEach(registration => {
                                registration.unregister()
                            })
                        })
                    window.location.href = '/top/'
                }
            })
        }

        const cancel = () =>{
            store.dispatch('asideMobileToggle')
        }

        return {
            toggleSidebar,
            isFullScreen,
            isAsideMobileExpanded,
            showSubmenuInfo,
            menuClick,
            cancel
        }
    }
}
</script>
